import URL from '../api_url';

export const PATIENT_API = `${URL}/patient`;

export const PATIENTS_API = `${URL}/patients`;